//////////////////
// Navigation Controller
//////////////////
App.Navigation = (function() {

	// Constants
	var options = {
		HOVER: "hover",
		OPEN: "open",
		POINT_DOWN: "o-down",
		TOUCH_OPEN: "nav-small-screen--open",
		LIGHT: "o-light"
	};

	var selectors = {
		navWrapper: ".site-nav",
		navItems: ".nav-items",
		navItem: ".nav-item",
		touchButton: ".nav-small-screen-button",
		membersIcon: ".nav-member .i-member",
		headerLogo: ".nav-header .site-logo",
		subMenu: ".nav-sub-menu",
		subMenuButton: ".nav-sub-menu-button"
	};

	var icons = {
		MENU: "i-menu",
		CLOSE: "i-close"
	}

	// Variables
	var nav, items, touchButton, memberIcon, logo, subMenuButtons;

	/*
	Add click handlers to navigation
	*/
	function initNavigation() {
		try {
			body = $("body");
			nav = $(selectors.navWrapper);
			items = nav.find(selectors.navItems);
			touchButton = $(selectors.touchButton);
			logo = $(selectors.headerLogo);
			membersIcon = nav.find(selectors.membersIcon);
			subMenuButtons = nav.find(selectors.subMenuButton);

			// Desktop nav helpers
			items.on("mouseover", desktopNavOnMouseOver);
			items.on("mouseout", desktopNavOnMouseOut);

			// Touch helpers
			touchButton.on("click", touchButtonOnClick);
			subMenuButtons.on("click", subMenuButtonOnClick);

		} catch(e) {
			console.log("Couldn't add handlers for " + selectors.navWrapper, e);
		}
	}

	function subMenuButtonOnClick(e) {
		var btn = $(e.target);
		var menu = btn.siblings(selectors.subMenu);
		menu.toggleClass(options.OPEN);
		btn.toggleClass(options.POINT_DOWN);
	}

	function touchButtonOnClick(e) {

		function updateButton() {
			// Update the menu button (close or menu icon)
			touchButton.toggleClass(icons.MENU);
			touchButton.toggleClass(icons.CLOSE);
			touchButton.toggleClass(options.LIGHT);
		}

		// Add open close to document
		body.toggleClass(options.TOUCH_OPEN);
		membersIcon.toggleClass(options.LIGHT);
		logo.toggleClass(options.LIGHT);

		if(body.hasClass(options.TOUCH_OPEN)) {
			updateButton();
			gsap.fromTo([nav, logo], { x:-window.innerWidth }, { x:0, duration: .5 });
		} else {
			updateButton();
			// gsap.fromTo(nav, { x:0 }, { x:-window.innerWidth, duration: .5 });
		}
	}

	function desktopNavOnMouseOver(e) {
		nav.addClass(options.HOVER);
		items.addClass(options.HOVER);
	}

	function desktopNavOnMouseOut(e) {
		nav.removeClass(options.HOVER);
		items.removeClass(options.HOVER);
	}

	App.register(function() {
		App.log("Registered: App.Navigation");
		//
		initNavigation();
	});

})();
